import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Card from "../../../UI/Card/Card";
import Button from "../../../UI/Button/Button"
import ErrorPanel, { ErrorSize } from "../../../UI/ErrorPanel/ErrorPanel";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

import InformationInput from "./InformationInput";
import * as ApplicationsUtils from "../../../Utils/ApplicationsUtils";
import * as ApplicationsActions from "../../../../middleware/Store/Actions/ApplicationsActions";
import * as SandBoxApplicationsActions from "../../../../middleware/Store/Actions/SandBoxApplicationsActions";
import * as ErrorUtils from "../../../Utils/ErrorUtils";
import LogService from "../../../../middleware/CommonSdk/LogService";

const LOG_TAG = "APP-EDITION-INFORMATION";

const Information = (props) => {
    const intl = useIntl();
    const [criteria, setCriteria] = useState(null);
    const [application, setApplication] = useState(null);
    const [progress, setProgress] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect application");
        if (props.applicationId) {
            const foundApplication = ApplicationsUtils.getApplicationById(props.applicationId, props.applications);
            setApplication(foundApplication);
            if (foundApplication) {
                setCriteria({
                    name: foundApplication.name,
                    activity: foundApplication.activity,
                    type: foundApplication.type
                });
            }
            if (props.applicationId !== application?.id) {
                setProgress(false);
                setErrorMessage("");
            }
        }
    }, [props.applications, props.applicationId]);

    const handleUpdate = () => {
        LogService.trace(LOG_TAG, "handleUpdate");

        setProgress(true);
        props.update(application?.id, criteria)
            .then(() => {
                LogService.debug(LOG_TAG, "handleUpdate success");
                setProgress(false);
                if (props.onActionSuccess) {
                    props.onActionSuccess();
                }
            })
            .catch((errorPayload) => {
                LogService.debug(LOG_TAG, "handleUpdate error");
                setProgress(false);
                setErrorMessage(ErrorUtils.getPrettyErrorMessage(errorPayload, intl));
                if (props.onActionFailed) {
                    props.onActionFailed();
                }
            });
    };

    const handleInputUpdate = (name, activity, type) => {
        LogService.trace(LOG_TAG, "handleInputUpdate");
        setCriteria({
            name: name,
            activity: activity,
            type: type
        });
    }

    LogService.trace(LOG_TAG, "render");
    const disableUpdateButton = !criteria || criteria.length === 0;

    return (
        <Card title={intl.messages.applicationEditionInformationTitle} header={props.showHeader}>
            {<InformationInput
                name={criteria?.name}
                activity={criteria?.activity}
                type={criteria?.type}
                isUpdateEnabled={props.isUpdateEnabled}
                onUpdate={handleInputUpdate}
            />}
            {props.isUpdateEnabled &&
                <div>
                    <Button
                        label={intl.messages.update}
                        icon={faEdit}
                        onClick={handleUpdate}
                        spinner={progress}
                        disabled={progress || disableUpdateButton}
                        className="btn-submit"
                    />
                    {errorMessage &&
                        <div className="col-10">
                            <ErrorPanel size={ErrorSize.Small} >{errorMessage}</ErrorPanel>
                        </div>
                    }
                </div>
            }
        </Card >
    );
}

Information.propTypes = {
    applicationId: PropTypes.string,
    isUpdateEnabled: PropTypes.bool,
    onActionSuccess: PropTypes.func,
    onActionFailed: PropTypes.func,
    showHeader: PropTypes.bool,
    isSandBoxApplication: PropTypes.bool
};

Information.defaultProps = {
    applicationId: "",
    isUpdateEnabled: false,
    onActionSuccess: null,
    onActionFailed: null,
    showHeader: true,
    isSandBoxApplication: false
}

const mapStateToProps = (state, props) => {
    return {
        applications: props.isSandBoxApplication ? state.sandBoxApplications.applications : state.applications.applications
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        update: (appId, criteria) => dispatch(props.isSandBoxApplication ? SandBoxApplicationsActions.updateApplication(appId, criteria) : ApplicationsActions.updateApplication(appId, criteria))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Information);